// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_2U3iJ","imageLink":"_3p1Z_","image":"_1Bdcn"};